import { COMMUNITY_ROUTES } from '~/constants/community';
import type { CommunityPost } from '~/interfaces/community';

export const communityPostPath = ({ id, attachable }: Pick<CommunityPost, 'id' | 'attachable'>): string =>
  attachable?.type === 'resource'
    ? COMMUNITY_ROUTES.pageResource(attachable.page.slug, attachable.slug)
    : COMMUNITY_ROUTES.post(id);
